import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/home1/voices-flower.png';
const _withScopeId = n => (_pushScopeId("data-v-66f2fd3f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home-voices",
  "aria-labelledby": "voices-title"
};
const _hoisted_2 = {
  class: "voices-shell"
};
const _hoisted_3 = {
  id: "voices-title"
};
const _hoisted_4 = {
  class: "voices-stage"
};
const _hoisted_5 = {
  class: "voices-grid"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "quote-mark",
  "aria-hidden": "true"
}, "“", -1));
const _hoisted_7 = {
  class: "voice-author"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "voices-flower-cell",
  "aria-hidden": "true"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
})], -1));
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'HomeVoices',
  setup(__props) {
    const {
      t
    } = useI18n();
    const voices = computed(() => [{
      id: 'chris',
      initials: 'CC',
      author: '@CryptoChris',
      quote: t('homepage.voices.chris')
    }, {
      id: 'diana',
      initials: 'DD',
      author: '@DeFiDiana',
      quote: t('homepage.voices.diana')
    }, {
      id: 'wolf',
      initials: 'WW',
      author: '@Web3Wolf',
      quote: t('homepage.voices.wolf')
    }, {
      id: 'mia',
      initials: 'MM',
      author: '@MetaMia',
      quote: t('homepage.voices.mia')
    }, {
      id: 'dan',
      initials: 'BD',
      author: '@BuilderDan',
      quote: t('homepage.voices.dan')
    }]);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)('homepage.voices.title')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(voices), voice => {
        return _openBlock(), _createElementBlock("article", {
          key: voice.id,
          class: "voice-card"
        }, [_hoisted_6, _createElementVNode("p", null, _toDisplayString(voice.quote), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("span", {
          class: _normalizeClass(["voice-avatar", `voice-avatar--${voice.id}`]),
          "aria-hidden": "true"
        }, _toDisplayString(voice.initials), 3), _createElementVNode("span", null, _toDisplayString(voice.author), 1)])]);
      }), 128))]), _hoisted_8])])]);
    };
  }
};